import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSegmentationChosen = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(() => dispatch({ type: 'SEGMENTATION_CHOSEN' }), [dispatch]);
};
